import React, { forwardRef } from 'react';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TInputShallowProps } from './types';

import style from './InputShallow.scss';

export const InputShallow = forwardRef<HTMLInputElement, TInputShallowProps>((
    {
        className = '',
        isOnlyNumber,
        isOnlyFloatNumber,
        disabled,
        isDisabledCopyPast = disabled,
        regex,
        ...props
    },
    ref
) => {
    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const valueInput = event?.target?.value;

        if (isOnlyNumber) {
            event.target.value = valueInput.replace(/[^0-9]/g, '');
        }

        if (isOnlyFloatNumber) {
            event.target.value = valueInput.replace(/[^\d.]/g, '');
        }

        if (regex) {
            event.target.value = valueInput.replace(regex, '');
        }

        if (props.onChange) {
            props.onChange(event);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement> & { target: HTMLInputElement}) => {
        if (isDisabledCopyPast) {
            const ctrlDown = event.ctrlKey || event.metaKey; // Mac support

            if (ctrlDown && event.altKey || !ctrlDown) {
                return;
            }

            if ([67, 86, 88].includes(event.keyCode)) {
                event.preventDefault();
            }
        }

        if (props.onKeyDown) {
            props.onKeyDown(event);
        }
    };

    const handlerDisabledCopyPast = (event: React.ClipboardEvent<HTMLInputElement> | React.MouseEvent<HTMLInputElement>) => {
        if (isDisabledCopyPast) {
            event.preventDefault();
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        if (isDisabledCopyPast) {
            event.preventDefault();
        }

        if (props.onPaste) {
            props.onPaste(event);
        }
    };

    return (
        <input
            ref={ref}
            disabled={disabled}
            className={clsx(style.input, className)}
            {...props}
            onKeyDown={handleKeyDown}
            onChange={handlerOnChange}
            onContextMenu={handlerDisabledCopyPast}
            onCut={handlerDisabledCopyPast}
            onCopy={handlerDisabledCopyPast}
            onPaste={handlePaste}
        />
    );
});
